import {
  Avatar,
  Box,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import addURLPrefix from "utils/addURLPrefix";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentsForMachineThunk } from "store/reducers/payments";

const AssignedPayments = ({ machine, handlePaymentMenuClick }) => {
  const paymentState = useSelector((state) => state.payments);
  const dispatch = useDispatch();
  useEffect(() => {
    if (machine) {
      dispatch(getPaymentsForMachineThunk(machine?.id));
    }
  }, [dispatch, machine, machine?.id]);
  return (
    <Box marginTop={2}>
      <Grid container>
        {
          console.log(paymentState?.paymentsForMachine[machine?.id])
        }
        {paymentState?.paymentsForMachine[machine?.id]?.map((paymentItem) => (
          <Grid item xs={12} md={4} key={paymentItem.id} sx={{ width: "100%" }}>
            <Paper sx={{ height: 80 }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Stack direction="row" alignItems="center" borderRadius="50%">
                  {paymentItem.image ? (
                    <LazyLoadImage
                      src={addURLPrefix(paymentItem.image)}
                      sx={{ height: 80, width: 80 }}
                      alt=""
                    />
                  ) : (
                    <Avatar variant="square" sx={{ height: 80, width: 80 }}>
                      {paymentItem.name[0]}
                    </Avatar>
                  )}
                  <Typography marginX={1}>{paymentItem.name}</Typography>
                </Stack>
                <IconButton
                  aria-label="settings"
                  sx={{
                    marginRight: 2,
                  }}
                  onClick={(e) => handlePaymentMenuClick(e, paymentItem)}
                >
                  <MoreVertIcon />
                </IconButton>
              </Stack>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AssignedPayments;
